export default __webpack_public_path__ + "pgnv-assets/84fe275551db19f91ea23ebf99d9b13f.png";